import React, { useState, useEffect } from 'react';

import { makeStyles } from '@mui/styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "@fontsource/mulish"; // Defaults to weight 400.

import Button from '@mui/material/Button';

import {getConfigValue} from './Config';
import SendMailDialog from './SendMailDialog';

import Snackbar from '@mui/material/Snackbar';

import LoadingButton from '@mui/lab/LoadingButton';


const useStyles = makeStyles(theme => ({   

    invoiceLineRow: {        
        
        backgroundColor: '#F3F3F3',
        display:'flex',
        flexDirection: 'column',
        justifyContent:'flex-start',
        alignItems: 'flex-start',
                
        padding: '.5em', 
        //marginLeft: '.5em',
        marginTop: '.2em',
        // width: '100%'
        
        
    }, 

    invoiceDetailsRow: {        
        fontFamily:'Mulish', 
        fontWeight: '200',
        backgroundColor: '#F3F3F3',
        display:'flex',
        flexDirection: 'row',
        justifyContent:'flex-start',
        alignItems: 'center',
        flexBasis: 30, 
        flexGrow: 1,
        // minWidth: 510,
        
        // padding: '.5em', 
        // margin: '.2em'
        
        
    }, 
    iconRow: {
        width:'15px'
    },
    rightColumn: {
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start',
        marginLeft: '1em', 
        
        fontSize: 13,
        fontWeight: 'bold',         
         wordBreak: 'break-word',

        
    },
    innerTopRow: {
        fontSize: 8,
        marginBottom: '.5em'
    },
    truncatedText: {
        width: '90px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }, 
    viewDownloadButtonLine: {
        marginTop: '5px',
        marginBottom: '10px',
    },



    }));


//---

const InvoiceItem = (props) => { 
    const classes = useStyles();

    var store = require('store')

    const [dialogOpen, setDialogOpen] = useState();
    const [emailFilehandle, setEmailFilehandle] = useState();

    const [showSnackbar, setShowSnackbar] = useState(false);

    const [loadingButtons, setLoadingButtons] = useState({});
    
    

    const isLoading = (buttonName) => {
        return loadingButtons[buttonName];
    }

    const setLoading =(buttonName, isLoading) => {
        var ldnButtons = {...loadingButtons};
        ldnButtons[buttonName] = isLoading;
        setLoadingButtons(ldnButtons);        
    }


    const confirmSendInvoiceToMail = async (invoiceNo, organizationNo, apiId) => {

        setLoading("send", true);
        const fileHandle= await prepareInvoice(invoiceNo, organizationNo, apiId); //prepare invoice pdf filehandle on server
        setEmailFilehandle(fileHandle);
        setLoading("send", false);

        setDialogOpen(true);
    }

    const sendInvoiceToEmail = async (emailAddress) => {  

        setLoading("send", true);
        
        if (emailAddress) { //user action confirmed
            const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Invoice/sendInvoiceToMail/${store.get("sessionToken")}/${emailFilehandle}/${emailAddress}/${props.invoiceJson.invoiceNumber}/${props.invoiceJson.customerId}`);            
            const json = await res.json();   

            if (json["result"]=="success") {
                setLoading("send",false);
                setShowSnackbar(true);
            }
                
        }
        else { //user action cancelled
            console.log('sending cancelled');
            setLoading("send",false);
        }


    }

    const viewInvoice = async (invoiceNo, organizationNo, apiId, download) => {      

        //console.log(props.invoiceJson);

        console.log("invoiceNo: ",invoiceNo);
        console.log("organizationNo: ", organizationNo);

        const fileHandle= await prepareInvoice(invoiceNo, organizationNo, apiId);                  

        if (!download)
            window.open(`${getConfigValue('serverBaseUrl')}/api/Invoice/viewInvoice/${fileHandle}`);                     
        else
            window.open(`${getConfigValue('serverBaseUrl')}/api/Invoice/downloadInvoice/${fileHandle}`);  
        
    }

    const prepareInvoice = async (invoiceNo, organizationNo, apiId) => {
        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Invoice/prepareInvoice/${store.get("sessionToken")}/${invoiceNo}/${organizationNo}/${apiId}`);            
        const json = await res.json();   

        if (json["result"]=="success")             
            return json["fileHandle"];                                
        else
            return null;
    }
   

    return(

        <div className={classes.invoiceLineRow}>

        <div className={classes.invoiceDetailsRow} onClick={() => props.selectInvoice(props.invoiceJson.invoiceNumber)}>
           <div className ={classes.iconRow}>
            <FontAwesomeIcon icon={props.icon} />
           </div>

           <div className={classes.rightColumn}>
                <div className={classes.innerTopRow}>
                    Fakturadato
                </div>
                <div className={classes.truncatedText}>
                    {new Date(props.invoiceJson.invoiceDate).toLocaleDateString('no-NO')} 
                </div>
           </div>

           <div className={classes.rightColumn}>
                <div className={classes.innerTopRow}>
                    Fakturanr
                </div>
                <div >
                    {props.invoiceJson.invoiceNumber} 
                </div>
           </div>

           <div className={classes.rightColumn}>
                <div className={classes.innerTopRow}>
                    Beløp
                </div>
                <div className={classes.truncatedText}>
                    {props.invoiceJson.grossAmount} NOK
                </div>
           </div>

           <div className={classes.rightColumn}>
                <div className={classes.innerTopRow}>
                    
                </div>
                <div >
                    {props.invoiceJson.statusMessage} 
                </div>
           </div>
          
        </div>


        {props.isSelected && 
         <div className={classes.viewDownloadButtonLine}>
          <Button  variant="contained" color="primary" size='small' onClick={() => viewInvoice(props.invoiceJson.invoiceNumber, props.invoiceJson.organizationNumber, props.invoiceJson.customerId, false)}   >
              Vis Faktura                    
          </Button> 
            &nbsp;
           <Button  variant="contained" color="primary" size='small'  onClick={() => viewInvoice(props.invoiceJson.invoiceNumber, props.invoiceJson.organizationNumber, props.invoiceJson.customerId, true)}   >
           Last Ned              
            </Button>
            &nbsp; 

            {props.admin && <LoadingButton loading={isLoading('send')} variant="contained" color="primary" size='small'  onClick={() => confirmSendInvoiceToMail(props.invoiceJson.invoiceNumber, props.invoiceJson.organizationNumber, props.invoiceJson.customerId)}   >
           Send             
            </LoadingButton>} 

            {dialogOpen && <SendMailDialog dialogText={'Angi epostadresse du vil sende til'} onCompletionFunc={sendInvoiceToEmail} 
                setDialogOpen={setDialogOpen} userName={props.userName}/>  } 

            <Snackbar
                open={showSnackbar}
                autoHideDuration={3000}
                onClose={_=>setShowSnackbar(false)}
                message='PDFen er sendt på epost'
            />
        
         </div>

            
         
        }


        </div>
    )
};

export default InvoiceItem;